import React, { useEffect, useState } from 'react'
import { css, useTheme } from '@emotion/react'
import Image from '../base-ui/Image'
import {
    AiOutlinePhone,
    AiOutlineFieldTime,
    AiOutlinePushpin,
    AiOutlineSearch,
    AiOutlineMobile,
    AiOutlineMail
} from 'react-icons/ai'
import ServiceBox from './ServiceBox'
import { MediaQuery } from '../base-ui/Utility'
import config from '../../../config.json'
import { GiHamburgerMenu } from 'react-icons/gi'
import { Nav } from '../webpage'
import { useDataProvider } from '../../hooks/dataProvider'
import SearchModal from './SearchModal'
import { Link } from '../base-ui'
import { useRouter } from 'next/router'
import SocialLinks from './SocialLinks'
import { IoLogoWhatsapp } from 'react-icons/io5'

const COMMON_ICONS = {
    phone: <AiOutlinePhone />,
    time: <AiOutlineFieldTime />,
    pin: <AiOutlinePushpin />,
    mobile: <AiOutlineMobile />,
    mail: <AiOutlineMail />,
    whatsapp: <IoLogoWhatsapp />,
}
function HeaderMiddleBar() {
    const theme = useTheme()
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false)
    const { data, setData } = useDataProvider()
    const { locale } = useRouter()
    useEffect(
        () => {
            setData({ visible: false })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    )
    const middleBarStyle = css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-grow: 1;
        flex-wrap: wrap;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        background-color: #ffffff;
        .service-list {
            display: none;
        }
        .service-list ul,
        .service-list-mobile ul {
            display: flex;
            align-items: center;
        }
        .service-list-mobile {
            ${['ar', 'fa'].indexOf(locale) !== -1
            ? 'padding-right: 40px;'
            : 'padding-left: 40px;'}
            border-top: 1px solid #eee;
            width: 100%;
        }
        .service-list-mobile ul {
            flex-wrap: wrap;
            justify-content: space-between;
            width: 100%;
            margin: 0 auto;
        }
        .service-list-mobile ul li {
            margin: 0.5rem 1.5rem !important;
            svg {
                font-size: 28px;
            }
        }
        .service-list-mobile ul li:last-child {
            margin: 0.5rem auto !important;
        }
        .service-list ul li,
        .service-list-mobile ul li {
            position: relative;
            display: inline-block;
            margin: 0 2rem;
        }
        .left-side {
            margin-right: auto;
            display: flex;
            gap: 1rem;
        }
        .service-list {
            margin-right: -2rem;
        }
        padding: 1rem 1rem;
        .extra-nav {
            padding: 20px 0 16px 0px;
            position: relative;
            border-left: 1px solid rgba(0, 0, 0, 0.1);
            .extra-cell {
                display: inline-block;
                margin-left: 10px;
                svg {
                    font-size: 24px;
                    color: ${theme.colors.primary};
                    font-weight: 100;
                }
            }
        }
        .mobile-navigation {
            display: block;
        }
        .site-logo {
            flex-basis: 40%;
        }
        .actionButton {
            .link a {
                padding: 0.25rem 0.5rem;
                background-color: ${theme.colors.primary};
                color: #fff;
            }
        }
        .service-list-mobile {
            display: flex;
            .social-icons {
                padding-top: 1rem;
                border-top: 1px solid #eee;
                width: 100%;
                ${['ar', 'fa'].indexOf(locale) !== -1
            ? 'right: -20px;'
            : 'left: -20px;'}
                .link a {
                    color: ${theme.colors.primary};
                    &:hover {
                        color: ${theme.colors.secondary};
                    }
                }
            }
        }
        ${MediaQuery('md', 'min')} {
            .service-list-mobile ul li:last-child {
                margin: 0.5rem 0 !important;
            }
        }
        ${MediaQuery('lg', 'min')} {
            .site-logo {
                flex-basis: 20%;
            }
            .actionButton {
                .link a {
                    padding: 1rem 2rem;
                }
            }
            .mobile-navigation {
                display: none;
            }
            padding: 1rem 5rem;
            .service-list {
                display: block;
            }
            .left-side,
            .service-list-mobile {
                display: none;
            }
        }
        ${MediaQuery('xl', 'min')} {
            padding: 1rem 10rem;
        }
        ${MediaQuery('xxl', 'min')} {
            padding: 1rem 20rem;
        }
    `
    return (
        <div css={middleBarStyle} className="middle-bar">
            <div className="site-logo">
                <Link href="/">
                    <Image
                        noStyle
                        src="/img/project/logo.png"
                        width={config.theme?.components?.logo?.width ?? 250}
                        height={config.theme?.components?.logo?.height ?? 80}
                        alt="site logo"
                        objectFit="contain"
                    />
                </Link>
            </div>
            <div className="left-side">
                <div className="extra-nav">
                    <div className="extra-cell">
                        <SearchModal
                            trigger={
                                <button
                                    id="quik-search-btn"
                                    type="button"
                                    className="site-button-link"
                                >
                                    <AiOutlineSearch />
                                </button>
                            }
                        />
                    </div>
                </div>
                <button
                    className="flex-item lg:hidden hamburger-menu"
                    onClick={() => {
                        setMobileMenuVisible(true)
                    }}
                >
                    <GiHamburgerMenu className="text-4xl" />
                </button>
            </div>
            <div className="service-list">
                <ul>
                    {config?.texts?.header_items?.map((i, idx) => {
                        if (i.type === 'button') {
                            return (
                                <li key={idx} style={{ margin: '0 1rem' }} css={css`${i.css ?? ''}`}>
                                    <div className="actionButton">
                                        <Link href={i.href}>{i.title}</Link>
                                    </div>
                                </li>
                            )
                        }
                        return (
                            <li key={idx} css={css`${i.css ?? ''}`}>
                                <ServiceBox
                                    icon={COMMON_ICONS[i.icon]}
                                    title={i.title}
                                    subtitle={i.subtitle}
                                />
                            </li>
                        )
                    })}
                </ul>
            </div>
            <div
                className="mobile-navigation"
                css={css`
                    .mobile-nav {
                        background-color: ${theme.colors.darkGray} !important;
                        .accordion-title,
                        a span {
                            outline-color: ${theme.colors.lighter};
                            color: ${theme.colors.darkGray};
                            background-color: ${theme.colors.lighterGray};
                        }
                        .accordion-content .link {
                            border-color: ${theme.colors.primary};
                        }
                    }
                `}
            >
                <Nav
                    items={data?.menuItems}
                    visible={mobileMenuVisible}
                    onClose={() => setMobileMenuVisible(false)}
                    type="mobile"
                />
            </div>
            <div className="service-list-mobile">
                <ul>
                    {config?.texts?.header_items?.map((i, idx) => {
                        if (i.type === 'button') {
                            return (
                                <li key={idx} style={{ margin: '0 1rem' }}>
                                    <div className="actionButton">
                                        <Link href={i.href}>{i.title}</Link>
                                    </div>
                                </li>
                            )
                        }
                        return (
                            <li key={idx}>
                                <ServiceBox
                                    icon={COMMON_ICONS[i.icon]}
                                    subtitle={i.title}
                                />
                            </li>
                        )
                    })}
                    <li className="social-icons">
                        <SocialLinks
                            socials={config?.texts?.social?.value}
                            style="justify-content: center;"
                        />
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default HeaderMiddleBar
